import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderContainerComponent } from '../landing-page/header/header.container.component';

@Component({
  selector: 'legal-ui',
  imports: [RouterOutlet, HeaderContainerComponent],
  templateUrl: './legal.component.html',
  styleUrl: './legal.component.scss',
})
export class LegalComponent {}
